import {
  isResourceIdAndNameResponseDTO,
  ResourceIdAndNameResponseApi,
} from "../Resource/Resource";

export interface LearningPathResourceResponseApi {
  learningPathResourceId: string;
  resource: ResourceIdAndNameResponseApi;
}

export class LearningPathResourceResponseImpl {
  learningPathResourceId: string;
  resource: ResourceIdAndNameResponseApi;

  constructor(learningPathResource: LearningPathResourceResponseApi) {
    this.learningPathResourceId = learningPathResource.learningPathResourceId;
    this.resource = learningPathResource.resource;
  }
}

export let isLearningPathResourceResponseDTO = (
  variable: unknown
): variable is LearningPathResourceResponseApi => {
  return (
    variable !== null &&
    variable !== undefined &&
    typeof variable === "object" &&
    "learningPathResourceId" in variable &&
    typeof variable.learningPathResourceId === "string" &&
    "resource" in variable &&
    isResourceIdAndNameResponseDTO(variable.resource)
  );
};
